import React, { useState } from 'react';
import UserPreferences from '../components/settings/UserPreferences';
import NotificationSettings from '../components/settings/NotificationSettings';
import CompanyConfiguration from '../components/settings/CompanyConfiguration';
import UserControl from '../components/settings/UserControl';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('preferences');

  const tabs = [
    { id: 'preferences', label: 'User Preferences', icon: '👤' },
    { id: 'users', label: 'Users Control', icon: '👥' },
    { id: 'notifications', label: 'Notifications', icon: '🔔' },
    { id: 'company', label: 'Company Settings', icon: '🏢' }
  ];

  const handleSettingChange = () => {
    // This function is called when settings components need to notify of changes
    // Currently no specific action needed as each component handles its own state
  };


  const renderTabContent = () => {
    switch (activeTab) {
      case 'preferences':
        return <UserPreferences onChange={handleSettingChange} />;
      case 'users':
        return <UserControl onChange={handleSettingChange} />;
      case 'notifications':
        return <NotificationSettings onChange={handleSettingChange} />;
      case 'company':
        return <CompanyConfiguration onChange={handleSettingChange} />;
      default:
        return <UserPreferences onChange={handleSettingChange} />;
    }
  };

  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Settings</h1>
        <p className="text-gray-600">Manage your preferences and company configuration</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        {/* Tabs Header */}
        <div className="border-b border-gray-200">
          <nav className="flex overflow-x-auto" aria-label="Settings tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-shrink-0 px-4 py-4 text-sm font-medium border-b-2 transition-colors duration-200 ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600 bg-blue-50'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center space-x-2">
                  <span className="text-lg">{tab.icon}</span>
                  <span className="hidden sm:inline">{tab.label}</span>
                </div>
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-6">
          {renderTabContent()}
        </div>

      </div>

    </div>
  );
};

export default Settings;
